import { Fragment } from 'react';
import {
	Box,
	Breadcrumb as DsBreadcrumb,
	BreadcrumbList,
	BreadcrumbItem,
	BreadcrumbLink,
	BreadcrumbPage,
	BreadcrumbSeparator,
} from '@dextech-ai/dex-design-system';
import { ReactComponent as IconHome } from '@/assets/svgs/breadcrumb-home.svg';

const Breadcrumb = ({ items, ariaLabel = 'Page trail' }) => {
	if (!items?.length) return null;

	return (
		<Box mb={3}>
		<DsBreadcrumb aria-label={ariaLabel}>
			<BreadcrumbList>
				{items.map((item, i) => {
					const isLast = i === items.length - 1;
					const isHome = item.isHomePage || item.link === '/';
					const hasLink = Boolean(item.link) && !isLast;
					const content = isHome ? <IconHome /> : item.label;
					return (
						<Fragment key={`${item.label ?? 'home'}-${i}`}>
							<BreadcrumbItem>
								{hasLink ? (
									<BreadcrumbLink href={item.link}>{content}</BreadcrumbLink>
								) : (
									<BreadcrumbPage>{content}</BreadcrumbPage>
								)}
							</BreadcrumbItem>
							{!isLast && <BreadcrumbSeparator />}
						</Fragment>
					);
				})}
			</BreadcrumbList>
		</DsBreadcrumb>
		</Box>
	);
};

export default Breadcrumb;
